/**
 * @generated SignedSource<<d86e08d1db212ce9dd4b2e6750649a42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DataFilterRendererQuery$variables = {};
export type DataFilterRendererQuery$data = {
  readonly allCategories: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly rowId: string;
        readonly title: string;
      } | null;
    }>;
  } | null;
};
export type DataFilterRendererQuery = {
  response: DataFilterRendererQuery$data;
  variables: DataFilterRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "condition",
        "value": {
          "active": true
        }
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1000
      }
    ],
    "concreteType": "CategoriesConnection",
    "kind": "LinkedField",
    "name": "allCategories",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoriesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rowId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "allCategories(condition:{\"active\":true},first:1000)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DataFilterRendererQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DataFilterRendererQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "7643728c23fc7813186fded2e3f6d0bd",
    "id": null,
    "metadata": {},
    "name": "DataFilterRendererQuery",
    "operationKind": "query",
    "text": "query DataFilterRendererQuery {\n  allCategories(first: 1000, condition: {active: true}) {\n    edges {\n      node {\n        id\n        rowId\n        title\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "988b695d9986ad835bf139ea205c3bdd";

export default node;
